import {
  takeLatest,
  takeLeading,
  put,
  select,
  all,
  call,
} from 'redux-saga/effects';
import axios from 'axios';
import {
  selectDof,
  selectSelectedFlightIds,
  selectFlightIds,
} from './flightData.selector';
import {
  getFlightIdsSuccess,
  getFlightIdsFailure,
  setFlightIdsLoading,
  setCustomerDataLoading,
  getFlightTimesSuccess,
  getFlightTimesStart,
  getFlightTimesFailure,
  getCustomerDataFailure,
  getCustomerDataSuccess,
  setCustomerCount,
} from './flightData.actions';

import { selectCurrentUser } from '../user/user.selector';
import FlightDataActionTypes from './flightData.types';

export function* getFlightIds() {
  try {
    const date = yield select(selectDof);
    const user = yield select(selectCurrentUser);
    yield put(setFlightIdsLoading(true));

    const response = yield call(axios, {
      url:
        process.env.REACT_APP_LOCAL_URL + '/automation/runflightidautomation',
      method: 'post',
      data: { date, userAuth: user },
    });

    if (response.data.flightIds) {
      yield put(getFlightIdsSuccess(response.data.flightIds));
      yield put(getFlightTimesStart());
    } else {
      alert('No flights for selected date.');
      yield put(getFlightIdsSuccess([]));
    }
  } catch (error) {
    yield put(getFlightIdsFailure(error));
  }
}

export function* getCustomerData() {
  try {
    const selectedFlightIds = yield select(selectSelectedFlightIds);
    const user = yield select(selectCurrentUser);
    yield put(setCustomerDataLoading(true));

    const response = yield call(axios, {
      url: process.env.REACT_APP_LOCAL_URL + '/automation/getcustomerdata',
      method: 'post',
      data: {
        flightIds: selectedFlightIds,
        userAuth: user,
      },
    });
    yield put(getCustomerDataSuccess(response.data.customerData));
    yield put(setCustomerCount(response.data.customerCount));

    if (response.data.customerData.length === 0) {
      alert('No customer for selected Flights');
    }
  } catch (error) {
    alert('Error occurred while getting customer data');
    yield put(getCustomerDataFailure(error));
  } finally {
    yield put(setCustomerDataLoading(false));
  }
}

export function* getFlightTimes() {
  try {
    const flightIds = yield select(selectFlightIds);
    const date = yield select(selectDof);
    const user = yield select(selectCurrentUser);
    yield put(setFlightIdsLoading(true));

    const response = yield call(axios, {
      url: process.env.REACT_APP_LOCAL_URL + '/automation/flightTimes',
      method: 'post',
      data: { date, flightIds: flightIds, userAuth: user },
    });

    if (response.data.flightTimes) {
      yield put(getFlightTimesSuccess(response.data.flightTimes));
    }
  } catch (error) {
    yield put(getFlightTimesFailure(error));
  } finally {
    yield put(setFlightIdsLoading(false));
  }
}

export function* onGetFlightIdsStart() {
  yield takeLeading(FlightDataActionTypes.GET_FLIGHT_IDS_START, getFlightIds);
}

export function* onGetFlightTimesStart() {
  yield takeLeading(
    FlightDataActionTypes.GET_FLIGHT_TIMES_START,
    getFlightTimes
  );
}

export function* onGetCustomerDataStart() {
  yield takeLatest(
    FlightDataActionTypes.GET_CUSTOMER_DATA_START,
    getCustomerData
  );
}

export function* flightDataSagas() {
  yield all([
    call(onGetCustomerDataStart),
    call(onGetFlightIdsStart),
    call(onGetFlightTimesStart),
  ]);
}
